"use client";

import { Button } from "@/components/ui/button";
import {
    Sheet,
    SheetContent,
    SheetTitle,
    SheetTrigger,
} from "@/components/ui/sheet";
import { Menu } from "lucide-react";
import { Logo } from "./Logo";
import { NavMenu } from "./NavMenu";
import { useTranslations } from "next-intl";
import Link from "next/link";
import { useLanguage } from "@/lib/LanguageContext";
import React from "react";

export const MobileNav = () => {
    const t = useTranslations('marketing.navbar');
    const { language } = useLanguage();
    const [loginUrl, setLoginUrl] = React.useState("#");
    const [signupUrl, setSignupUrl] = React.useState("#");

    React.useEffect(() => {
        const hostname = window.location.hostname;
        const currentLang = language || 'en';

        let baseUrl = "https://app.ecommaps.com";
        if (hostname === "localhost") {
            baseUrl = "http://app.localhost:3000";
        }

        setLoginUrl(`${baseUrl}/${currentLang}/login`);
        setSignupUrl(`${baseUrl}/${currentLang}/signup`);
    }, [language]);

    return (
        <Sheet>
            <SheetTitle className="sr-only">Navigation Menu</SheetTitle>
            <SheetTrigger asChild>
                <Button variant="outline" size="icon">
                    <Menu />
                </Button>
            </SheetTrigger>
            <SheetContent side={language === 'ar' ? 'right' : 'left'}>
                <Logo />
                <NavMenu orientation="vertical" className="mt-12" />

                <div className="mt-8 space-y-4">
                    <Link href={loginUrl} className="block">
                        <Button variant="outline" className="w-full">
                            {t('login')}
                        </Button>
                    </Link>
                    <Link href={signupUrl} className="block">
                        <Button className="w-full">
                            {t('startNow')}
                        </Button>
                    </Link>
                </div>
            </SheetContent>
        </Sheet>
    );
};

export default MobileNav;
